import * as React from 'react';
import clsx from 'clsx';

interface MockWaveformProps {
  waveColor?: string;
  progressColor?: string;
}

export const MockWaveform: React.FC<MockWaveformProps> = ({
  waveColor = 'bg-white',
  progressColor = 'bg-accent-300',
}) => {
  // Static height pattern
  const bars = [
    20, 40, 60, 30, 50, 80, 45, 30, 60, 90, 70, 40, 25, 50, 75, 40, 60, 90, 50, 30, 20, 40, 60, 30,
    50, 80, 45, 30, 60, 90,
  ];

  return (
    <div className='flex h-[30px] items-center gap-[2px]'>
      {bars.map((height, i) => (
        <div
          key={i}
          className={clsx(
            'w-[3px] rounded-full', // barWidth=3 from reference
            // First 40% progress color, rest wave color
            i < 12 ? progressColor : waveColor
          )}
          style={{
            height: `${height}%`,
            backgroundColor: undefined, // utilizing classes mostly
          }}
        />
      ))}
    </div>
  );
};
